module.exports = __webpack_public_path__ + "static/img/nodata.ebb74f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/nodata.png
// module id = f0hK
// module chunks = 90